module.exports = __webpack_public_path__ + "img/j1.c57cd706.webp";